import { render, staticRenderFns } from "./note_suggestions.vue.js?vue&type=template&id=cc2f4d3e&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./note_suggestions.vue?vue&type=template&id=cc2f4d3e&vue3"
import script from "./note_suggestions.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./note_suggestions.vue?vue&type=script&lang=js&vue3"
export * from "./note_suggestions.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./note_suggestions.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports